import React from "react";

import ReactMarkdown from "react-markdown";

import { FooterData } from "data/footer";

import { HeaderButtons } from "../common/HeaderButtons/HeaderButtons";
import { MarketingFooter } from "../common/MarketingFooter";
import { MarketingHeaderWithAuth } from "../common/MarketingHeaderWithAuth";
import { PageSEO } from "../seo";
import * as styles from "./markdown.css";

export interface MarkdownObject {
  content: string;
  data: {
    [key: string]: any;
  };
}

interface Props {
  markdownData: string;
  footerData: FooterData;
}

export const Markdown = ({ markdownData, footerData }: Props): React.ReactElement => {
  const { content, data } = JSON.parse(markdownData);
  return (
    <>
      <PageSEO title={data.title} />

      <MarketingHeaderWithAuth
        renderUnauthContent={() => (
          <HeaderButtons
            items={[
              { label: "Explore", href: "/homepage" },
              { label: "Question?", href: "/faq" },
            ]}
          />
        )}
      />
      <div className={styles.staticMarkdownContainer}>
        <ReactMarkdown className={styles.staticMarkdownContent}>{content}</ReactMarkdown>
      </div>
      <MarketingFooter data={footerData} />
    </>
  );
};
